import Swal from "sweetalert2";
import HelperMixin from '../../../../Shared/HelperMixin.vue'
export default {
    name: "AddUser",
    mixins: [HelperMixin],
    async created() {
        await this.CheckLoginStatus();
        await this.GetAllOffices(2);
        this.GetLocalOffice();

        this.GetInfo();
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,

            Info: [],

            OfficeId: '',
            Search: '',
            From: '',
            To: '',
            SelectedItem: '',


            LocalOffices: [],

           
            ruleForm: {
                Id: 0,
                Type: 2,
                OfficeId: '',
                OfficeName: '',
                LocalOfficeId: '',
                LocalOfficeName: '',

                ReferenceNumber: '',
                MessageDate: '',

                Subject: '',
                Content: '',

                Notes: '',

                Attachments: [],

                ImageName: '',
                ImageType: '',
                fileBase64: '',

            },
            rules: {

                OfficeId: this.$helper.RequiredInput(' وارد من'),
                LocalOfficeId: this.$helper.RequiredInput(' موجه إلى'),

                ReferenceNumber: this.$helper.RequiredInput('الرقم الإشاري '),
                MessageDate: this.$helper.RequiredInput('تاريخ الرسالة'),

                Subject: this.$helper.RequiredInput('الموضوع '),
                Content: this.$helper.RequiredInput('المحتوي '),
            },

            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false


        };
    },

    methods: {

        GetLocalOffice() {
            this.ruleForm.LocalOfficeId = '';
            this.LocalOffices = [];
            this.$blockUI.Start();
            this.$http
                .GetOfficesById(1)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.LocalOffices = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.From)
                this.From = this.ChangeDate(this.From);

            if (this.To)
                this.To = this.ChangeDate(this.To);

            this.$blockUI.Start();
            this.$http
                .GetInbox(this.pageNo, this.pageSize, this.OfficeId, this.Search, this.From, this.To, 2)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.state = 1;
            this.ruleForm.Id = item.id;
            this.ruleForm.OfficeId = item.fromId;
            this.ruleForm.OfficeName = item.from;
            this.ruleForm.LocalOfficeId = item.toId;
            this.ruleForm.LocalOfficeName = item.to;

            this.ruleForm.ReferenceNumber = item.referenceNumber;
            this.ruleForm.MessageDate = item.messageDate;
            this.ruleForm.Subject = item.subject;
            this.ruleForm.Content = item.content;
            this.ruleForm.Notes = item.notes;
            this.ruleForm.Attachments = item.messageAttachments;
        },

        OpenEditInfo(item) {
            this.SelectedItem = item;
            this.state = 2;
            this.ruleForm.Id = item.id;
            this.ruleForm.OfficeId = item.fromId;
            this.ruleForm.OfficeName = item.from;
            this.ruleForm.LocalOfficeId = item.toId;
            this.ruleForm.LocalOfficeName = item.to;
            this.ruleForm.ReferenceNumber = item.referenceNumber;
            this.ruleForm.MessageDate = item.messageDate;
            this.ruleForm.Subject = item.subject;
            this.ruleForm.Content = item.content;
            this.ruleForm.Notes = item.notes;
            this.ruleForm.Attachments = item.messageAttachments;
        },


        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.SelectedItem.id);
                    this.$blockUI.Start();
                    this.$http.EditOutIncome(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.resetForm(formName);
                            this.GetInfo(this.pageNo);
                            this.state = 0;
                            this.SelectedItem = '';
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                        });
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.RemoveAllAttachment();
        },

        RemoveAllAttachment() {
            const elements = document.querySelectorAll('.el-upload-list--picture-card .el-upload-list__item');
            elements.forEach(element => element.remove());
            this.ruleForm.Attachments = [];
        },

        Delete(Id) {
            Swal.fire({
                title: "هـل انت متأكد من عملية الحذف ؟",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `تأكيد العملية`,
                denyButtonText: `الغاء العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteMessage(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                        });
                    return;
                }
            });
        },

        //Image Handle
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        handleDownload(file) {
            const link = document.createElement('a');
            link.href = file.url;
            link.target = '_blank';
            link.download = '';
            link.click();
        },

        handleRemove(Id) {
            Swal.fire({
                title: "هـل انت متأكد من عملية حذف المرفق ؟",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `تأكيد العملية`,
                denyButtonText: `الغاء العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteMessageAttachment(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.AddViewDilogRequest = false;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                        });
                    return;
                }
            });
        },

        //Support Info
        Back() {
            this.state = 0;
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },

    },
};
